import { URL } from ".";

const getWeatherForecasts = async (resortId = null) => {
  try {
    const params = resortId ? `?resortId=${resortId}` : '';
    const response = await fetch(`${URL}/weather${params}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      }
    });
    return await response.json();
  } catch (error) {
    console.error('Error fetching weather:', error);
    return null;
  }
}

export { getWeatherForecasts }
